import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["label", "lovedOneField", "lovedOneInput", "container"];

  connect() {
    this.toggle();
  }

  toggle() {
    const checked = this.element.querySelector('[name="pp_crem_quote[relationship]"]:checked');
    if (!checked) return;

    const isLovedOne = checked.value !== "self";

    this.labelTargets.forEach((label) => {
      const text = isLovedOne ? label.dataset.lovedOneLabel : label.dataset.selfLabel;
      if (!text) return;

      const textNode = Array.from(label.childNodes).find(
        (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim(),
      );

      if (textNode) {
        textNode.textContent = `${text} `;
      } else {
        label.prepend(document.createTextNode(`${text} `));
      }
    });

    this.lovedOneFieldTarget.classList.toggle("hidden", !isLovedOne);
    this.lovedOneInputTarget.required = isLovedOne;
    if (!isLovedOne) this.lovedOneInputTarget.value = "";

    this.containerTarget.classList.toggle("lg:grid-cols-3", isLovedOne);
  }
}
